export default "__VITE_ASSET__CKvR4GXR__"